import * as yup from 'yup';
import Payment from 'payment';

export const creditCardInitialValues = {
  cardNumber: '',
  securityCode: '',
  expiration: '',
};

export const creditCardValidation = yup.object().shape({
  cardNumber: yup
    .string()
    .required('Card number is required')
    .test('is-card-number-valid', 'Card number is not valid', value => {
      if (!value) {
        // Let the .required() test handle it
        return true;
      }

      return Payment.fns.validateCardNumber(value);
    }),

  securityCode: yup
    .string()
    .required('Required')
    .test('is-cvv-valid', 'Invalid', value => {
      if (!value) {
        // Let the .required() test handle it
        return true;
      }

      return Payment.fns.validateCardCVC(value);
    }),

  expiration: yup
    .string()
    .required('Required')
    .test('is-expiry-valid', 'Invalid', value => {
      if (!value) {
        // Let the .required() test handle it
        return true;
      }

      return Payment.fns.validateCardExpiry(value);
    }),
});
